module.exports = __webpack_public_path__ + "static/media/15.c7a68fe4.mp3";